import * as React from 'react';
import { RouterProvider } from 'react-router-dom';
import { AuthProvider } from './state/auth-state';
import { SubdomainProvider } from './state/subdomain-state';
import { router } from './routes';

/**
 * Root application component.
 * Composes providers in the order specified by FRONTEND_CONSOLE_GUIDE.md:
 * AuthProvider > SubdomainProvider > RouterProvider
 */
export function App(): React.JSX.Element {
  return (
    <AuthProvider>
      <SubdomainProvider>
        <RouterProvider router={router} />
      </SubdomainProvider>
    </AuthProvider>
  );
}
